module.exports = __webpack_public_path__ + "static/media/link.4ab53dce.png";